import React, { useEffect, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { notification } from "antd";
import { useDispatch, useSelector } from "react-redux";
import OtpInput from "react-otp-input";
import { login } from "../../redux/auth";
import { IconsLoader } from "../../imports/icon";
import { useEnvironment } from "../../context/EnvironmentContext";
// New Functions
import { useEventsListenersGTAG } from "./customHooks/useUtility";
import useSignInHook from "./customHooks/useSigninHook";
import Loading from "./components/Loading";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

const LoginCard = () => {
  const [value, setValue] = React.useState("");
  const [api, contextHolder] = notification.useNotification();
  const [otp, setOtp] = useState(false);
  const [otpCheck, setOTPCheck] = React.useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [error, setError] = useState(null);
  const { isWebViewApp } = useEnvironment();
  const navigation = useNavigate();

  // new handler

  let { userAuthentication, isSubscribed, loading, userObj } = useSignInHook();
  const dispatch = useDispatch();
  const language = useSelector((state) => state.lang.language);
  const [subscribers, setSubsribe] = useState("");

  const validateOTPcode = async (phone, otp) => {
    try {
      setOTPCheck(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL_FUNCTION}/registerDevice`,
        {
          method: "POST", // or 'PUT'
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ phone: phone, otp: otp }),
        }
      );
      const res = await response.json();
      useEventsListenersGTAG({
        action: "OTP Validations",
        category: "auth",
        label: "otp request validate",
        value: value,
      });
      if (res?.error) {
        setError(res.error);
        setOTPCheck(false);

        return null;
      } else if (res?.token) {
        await dispatch(login(res));
        setOTPCheck(false);
        navigation({ pathname: "/games" });
      } else {
        setOTPCheck(false);

        return null;
      }
    } catch (e) {
      setOTPCheck(false);
      return null;
    }
  };

  const openNotificationWithIcon = (type, title, body, phone) => {
    api[type]({
      message: title,
      description: body,
    });
  };

  const signInPhone = async (phone) => {
    if (!phone) {
      phone = "";
    }
    if (isValidPhoneNumber(phone)) {
      useEventsListenersGTAG({
        action: "Login Attempted",
        category: "Authentication",
        label: `${phone} Attempted to login`,
        value: phone,
      });
      let user = await userAuthentication(phone);

      if (user?.isSubscribed) {
        useEventsListenersGTAG({
          action: "Subscribed Login Attempted",
          category: "Authentication",
          label: `${phone} Attempted to login`,
          value: phone,
        });

        openNotificationWithIcon(
          "success",
          "Welcome back, we just sent you an otp to login",
          `${phone} is subscribed to kinet store`
        );
        setOtp(true);
      } else {
        useEventsListenersGTAG({
          action: "New User Login Attempted",
          category: "Authentication",
          label: `${value} Attempted to login`,
          value: value,
        });

        openNotificationWithIcon(
          "info",
          "Please Subscribe to gain access or explore other options with our telegram bot",
          `${value} is currently not  subscribed to kinet store`
        );
      }
    } else {
      // console.log((isValidPhoneNumber(phone, 'ET')))
    }
    // Primery Validation
  };
  useEffect(() => {
    if (otpValue.length >= 4) {
      validateOTPcode(value, otpValue);
    }
  }, [otpValue]);

  useEffect(() => {
    if (isWebViewApp) {
      // console.log("i am now here", window.parent)
    }
  }, []);

  const setOtpFucn = (e) => {
    setOtpValue(e);
  };

  useEffect(() => {
    setSubsribe(language.subscribeTo);
  }, []);

  return (
    <div className="rounded-3xl border   flex flex-col items-center  justify-between  py-10 sm:py-12  bg-white min-h-max  h-[85%] sm:h-[80%]  w-full sm:w-[450px] shadow-sm">
      {contextHolder}
      <h1 className=" text-3xl sm:text-4xl text-light-green  text-center  font-gotham font-light capitalize mb-4">
        {language?.welcome1 || "WELCOME BACK"}
      </h1>

      <div className=" w-full flex flex-col items-center justify-center gap-3 sm:gap-6">
        <div className=" w-full flex flex-col items-center justify-center gap-1">
          <label className=" w-[90%] text-start text-sm sm:text-base font-gothaml">
            {language?.userorphone || "Phone Number"}
          </label>
          <PhoneInput
            className="w-[90%] rounded-full h-10 px-3 border-light-green border-2 text-xs outline-light-green placeholder:text-xs placeholder:text-gray-500 "
            inputClassName=""
            placeholder={
              language?.enterphonenumber || "Enter your Phone Number"
            }
            defaultCountry="ET"
            value={value}
            onChange={(e) => {
              setOtpValue("");
              setValue(e);
              signInPhone(e);
            }}
          />
        </div>
        <div className="w-[90%] flex items-center gap-2">
          <input
            type="checkbox"
            id="rememberMe"
            className="border-light-green font-gothaml"
          />
          <label
            htmlFor="rememberMe"
            className=" text-xs sm:text-sm font-gothaml"
          >
            {language?.persist || "Remember me"}
          </label>
        </div>
      </div>
      {otp ? (
        <div className="mb-5 mt-10">
          <OtpInput
            value={otpValue}
            onChange={(e) => setOtpFucn(e)}
            isDisabled={otpCheck}
            numInputs={4}
            inputStyle={{
              padding: "10px",
              fontSize: "18px",
              textAlign: "center",
              color: "#000",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
              borderRadius: "8px",
              width: "50px",
              height: "50px",
              outlineColor: "#8dc63f",
            }}
            renderSeparator={<span className="w-3 md:w-5" />}
            renderInput={(props) => <input {...props} />}
          />
        </div>
      ) : null}
      {error && (
        <p className="text-red-500 text-center">
          {error}
          <a
            onClick={async () => {
              await setOtp(false);
              await setError(null);
              await setOtpValue("");
              await signInPhone(value);
            }}
            className="px-2 font-extralight cursor-pointer text-[#FE9902]"
          >
            Resend
          </a>
        </p>
      )}
      {otpCheck && <Loading />}
      <p
        className={`text-black pt-10 text-center text-xs md:text-[13px] pb-5 max-w-[100vw] font-milkr`}
      >
        {language?.rules || "Send ok to 9871 to Subscribe"}
      </p>
      <div className="w-[90%] flex flex-col items-center justify-center space-y-10">
        {/* Subscribe via SMS button (was LOGIN) */}
        {!otp && (
          <a
            disabled={loading}
            href="sms:9871?body=ok"
            className="text-white text-lg font-gotham bg-light-green h-[45px] w-full rounded-[41px] shadow-[inset_-3px_-3px_6px_#62ac00,inset_1px_1px_3px_#63ac0040,0px_4px_12px_#63ac0099] active:shadow-[inset_3px_3px_6px_#62ac00,inset_-1px_-1px_3px_#63ac0040] transition-all duration-150 flex items-center justify-center relative"
          >
            <div className="absolute xl:text-[1vw]  text-[white] font-milkr text-md uppercase ">
              {loading ? (
                <Loading />
              ) : (
                <p className=" text-white">
                  {language?.subscribeTo || "Subscribe"}
                </p>
              )}
            </div>
          </a>
        )}

        {/* Terms & Privacy Text */}
        <div className="text-center w-full px-2">
          <h1 className="text-slate-900 text-sm font-light">
            {language?.privecy ||
              "By entering this site you confirm that you accept our"}
            <Link className="  text-[#8DC73F]  px-1" to="/terms-and-service">
              {language?.termandservice || "Terms and service"}
            </Link>
            {language?.and || "and"}
            <Link className=" text-[#8DC73F]  px-1" to="/privacy">
              {language?.privecyPolicy || "Privacy Policy"}
            </Link>
          </h1>
        </div>
      </div>
    </div>
  );
};

export default LoginCard;
